import gql from 'graphql-tag';
import { templateGQLFields } from './template.fields.js';
export function getTemplatesGQLQuery(fields) {
    return gql `
    query templates(
      $after: String
      $before: String
      $limit: Int!
      $offset: Int
      $reverse: Boolean
      $entityTypes: [TemplateEntityType!]
      $status: StoreItemStatus
    ) {
      templates(
        after: $after
        before: $before
        limit: $limit
        offset: $offset
        reverse: $reverse
        entityTypes: $entityTypes
        status: $status
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${templateGQLFields(fields)}
          }
        }
        nodes {
          ${templateGQLFields(fields)}
        }
      }
    }
  `;
}
//# sourceMappingURL=templates.gql.js.map